import React from 'react';
import { InputNumber, Space, Typography, Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ServingScaler = ({ currentServings, onChange }) => {
  const handleDecrement = () => {
    if (currentServings > 1) {
      onChange(currentServings - 1);
    }
  };

  const handleIncrement = () => {
    onChange(currentServings + 1);
  };

  return (
    <Space align="center" size="middle" className="serving-scaler">
      <Text strong style={{ fontSize: '16px' }}>Servings:</Text>
      <Button
        icon={<MinusOutlined />}
        onClick={handleDecrement}
        disabled={currentServings <= 1}
        size="small"
      />
      <InputNumber
        min={1}
        max={999}
        value={currentServings}
        onChange={(value) => value && onChange(value)}
        style={{ width: 70 }}
        controls={false}
      />
      <Button
        icon={<PlusOutlined />}
        onClick={handleIncrement}
        size="small"
      />
    </Space>
  );
};

export default ServingScaler;
